<template>
 <v-row>
   <v-dialog v-model="showDialog" scrollable max-width="400px" max-height="90%">
     <v-card>
       <v-card-title style="padding: 5px 0 0 5px;">
         <v-col cols="12">
					<span style="font-size: 20px;">
						{{ $t('wkt.admin.customers.window.delete_title') }}
					</span>
           <!-- <v-btn icon style="top: -20px; left: 10px; float: right;">
             <v-icon @click="showDialog=false">close</v-icon>
           </v-btn> -->
				</v-col>          
       </v-card-title>
			<v-divider></v-divider>
       <v-card-text style="padding-bottom: 0;">
				<v-container class="pa-0">
					<v-form ref="form">								
						<v-row class="ma-0">
							<v-col cols="12">
								<v-text-field
									ref="cif"
									v-model="cif"
									:label="$t('wkt.admin.customers.window.tax_id_number')"
									autocomplete="none"
									:error-messages="errorMessages"
									max="200" />
							</v-col>													
						</v-row>
					</v-form>
				</v-container>
       </v-card-text>
       <v-divider></v-divider>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.confirm').toUpperCase() }}</v-btn>
         <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

 </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import gwt from '../../api/gwt'

export default {
	name: 'DeleteCustomerDialog',
	mixins: [BaseModule],
	components: {
	},
	data () {
		return {
			showDialog: false,
			loading: false,
			company: null,
			country: null,
			msgCb: null,
			errorMessages: '',
		}
	},
	methods: {
		open: function(company, country, msgCb) {
			if (this.$refs.form) {
				this.$refs.form.resetValidation();
			}

			this.cif = null;
			this.company = company;
			this.country = country;
			this.msgCb = msgCb;
			this.errorMessages = '';

			this.showDialog = true;
		},
		ok: function() {
			this.errorMessages = '';

			if (!this.cif) {
				this.errorMessages = this.$t('wkt.admin.common.validation-utils.required_field');
				return;
			}

			if (!gwt.validateCIFOrDNI(this.country.id, this.cif)) {
				this.errorMessages = this.$t('wkt.admin.common.validation-utils.invalid_field');
				return;
			}

			if (!this.company.cif || this.cif.toUpperCase() != this.company.cif.toUpperCase()) {
				// Cif incorrecto o el cliente no tiene Cif
				this.errorMessages = this.$t('wkt.admin.customers.window.delete_error_cif');
				return;
			}

			this.showDialog = false;
			
			if (this.msgCb) {
				this.msgCb();
			}
		},
	},
}
</script>